import React, {Fragment} from "react";
import PropTypes from "prop-types";
import moment from "moment";
import Page from "../../../../../components/BaseComponents/Page/Page";
import {FaSolidIcon} from "../../../../../components/FontAwesomeIcons";
import {InputDatepicker} from "../../../../../components/BaseComponents/InputDatepicker";
import {ModuloHRAPI} from "../../../../../api/ModuloHR/ModuloHRAPI";
import {swal, swalError, swalLoading, swalSuccess} from "../../../../../helpers/SweetAlertWrapper";

export default class NewAwayTripPage extends React.Component {
    constructor(props) {
        super(props);
        const defaultStaffId = props.selectedStaffId || this.getDefaultStaffId(props.staffList);
        this.state = {
            id_dipendente: defaultStaffId,
            start_date: "",
            start_date_display: "",
            end_date: "",
            end_date_display: "",
            reason_id: "",
            route_id: "",
            vehicle_id: "",
            reasons: [],
            routes: [],
            vehicles: [],
            loadingLookups: false
        };
    }

    componentDidMount() {
        this.fetchLookups(this.state.id_dipendente);
    }

    getDefaultStaffId = staffList => {
        if (!staffList || !staffList.length) return null;
        return staffList[0].id_dipendente || null;
    }

    handleStaffChange = e => {
        const id_dipendente = parseInt(e.target.value, 10) || null;
        this.setState({
            id_dipendente: id_dipendente,
            reason_id: "",
            route_id: "",
            vehicle_id: "",
            reasons: [],
            routes: [],
            vehicles: []
        }, () => this.fetchLookups(id_dipendente));
    }

    handleStartDateChange = e => {
        const selectedDate = e.value;
        this.setState({
            start_date: moment(selectedDate).format("YYYY-MM-DD"),
            start_date_display: moment(selectedDate).format("DD-MM-YYYY")
        });
    }

    handleEndDateChange = e => {
        const selectedDate = e.value;
        this.setState({
            end_date: moment(selectedDate).format("YYYY-MM-DD"),
            end_date_display: moment(selectedDate).format("DD-MM-YYYY")
        });
    }

    handleReasonChange = e => this.setState({reason_id: e.target.value});
    handleRouteChange = e => this.setState({route_id: e.target.value});
    handleVehicleChange = e => this.setState({vehicle_id: e.target.value});

    fetchLookups = id_dipendente => {
        if (!id_dipendente) return;
        this.setState({loadingLookups: true});
        Promise.all([
            ModuloHRAPI.AwayTrips.reasonsList(id_dipendente),
            ModuloHRAPI.AwayTrips.routesList(id_dipendente),
            ModuloHRAPI.AwayTrips.vehiclesList(id_dipendente)
        ])
            .then(([reasons, routes, vehicles]) => {
                this.setState({
                    reasons: reasons || [],
                    routes: routes || [],
                    vehicles: vehicles || [],
                    loadingLookups: false
                });
            })
            .catch(error => {
                this.setState({loadingLookups: false});
                swalError(error || "Non e' stato possibile caricare i dati della trasferta");
            });
    }

    validateForm = () => {
        if (!this.state.id_dipendente) {
            swalError("Specifica un collaboratore valido");
            return false;
        }
        if (!this.state.start_date) {
            swalError("Specifica una data inizio valida");
            return false;
        }
        if (!this.state.end_date) {
            swalError("Specifica una data fine valida");
            return false;
        }
        const startDate = moment(this.state.start_date, "YYYY-MM-DD", true);
        const endDate = moment(this.state.end_date, "YYYY-MM-DD", true);
        if (endDate.isBefore(startDate)) {
            swalError("La data fine non puo' essere precedente alla data inizio");
            return false;
        }
        if (!this.state.reason_id) {
            swalError("Specifica un motivo valido");
            return false;
        }
        if (!this.state.route_id) {
            swalError("Specifica un percorso valido");
            return false;
        }
        return true;
    }

    handleSubmit = _ => {
        if (!this.validateForm()) return;

        const payload = {
            id_dipendente: this.state.id_dipendente,
            start_date: this.state.start_date,
            end_date: this.state.end_date,
            reason_id: this.state.reason_id,
            route_id: this.state.route_id,
            vehicle_id: this.state.vehicle_id || null
        };

        swalLoading();
        ModuloHRAPI.AwayTrips.save(payload)
            .then(_ => {
                swal.safeClose();
                swalSuccess("Richiesta di trasferta salvata");
                if (this.props.onTripCreated) {
                    this.props.onTripCreated(this.state.id_dipendente);
                }
            })
            .catch(error => {
                swal.safeClose();
                swalError(error || "Non e' stato possibile salvare la trasferta");
            });
    }

    renderStaffOptions = _ => {
        return (this.props.staffList || []).map(staff => {
            const label = staff.negozio?.nome ? `${staff.nome} - ${staff.negozio.nome}` : staff.nome;
            return <option key={staff.id_dipendente} value={staff.id_dipendente}>{label}</option>;
        });
    }

    renderReasonOptions = _ => {
        return (this.state.reasons || []).map(reason => {
            return <option key={reason.reason_id} value={reason.reason_id}>{reason.name}</option>;
        });
    }

    renderRouteOptions = _ => {
        return (this.state.routes || []).map(route => {
            const label = `${route.from_city_name || "-"} - ${route.to_city_name || "-"}`;
            return <option key={route.route_id} value={route.route_id}>{label}</option>;
        });
    }

    renderVehicleOptions = _ => {
        return (this.state.vehicles || []).map(vehicle => {
            const label = `${vehicle.brand || ""} ${vehicle.model || ""} - ${vehicle.license_plate || "-"}`.trim();
            return <option key={vehicle.vehicle_id} value={vehicle.vehicle_id}>{label}</option>;
        });
    }

    render() {
        return (
            <Fragment>
                <Page
                    title={"Nuova trasferta"}
                    leftIcon={<FaSolidIcon name={"chevron-left"}/>}
                    onLeftIconClick={this.props.onDismiss}
                    active={this.props.active}
                    content={
                        <div className={"container py-3"}>
                            <div className={"form-group"}>
                                <label>Collaboratore</label>
                                <select
                                    className={"form-control"}
                                    value={this.state.id_dipendente || ""}
                                    onChange={this.handleStaffChange}
                                >
                                    {this.renderStaffOptions()}
                                </select>
                            </div>

                            <div className={"form-row"}>
                                <div className={"form-group col-6"}>
                                    <label>Data inizio</label>
                                    <InputDatepicker
                                        className={"form-control bg-main-z3"}
                                        value={this.state.start_date_display}
                                        onChange={this.handleStartDateChange}
                                    />
                                </div>
                                <div className={"form-group col-6"}>
                                    <label>Data fine</label>
                                    <InputDatepicker
                                        className={"form-control bg-main-z3"}
                                        value={this.state.end_date_display}
                                        onChange={this.handleEndDateChange}
                                    />
                                </div>
                            </div>

                            <div className={"form-group"}>
                                <label>Motivo</label>
                                <select
                                    className={"form-control"}
                                    value={this.state.reason_id}
                                    onChange={this.handleReasonChange}
                                    disabled={this.state.loadingLookups}
                                >
                                    <option value={""}>Seleziona motivo</option>
                                    {this.renderReasonOptions()}
                                </select>
                            </div>

                            <div className={"form-group"}>
                                <label>Percorso</label>
                                <select
                                    className={"form-control"}
                                    value={this.state.route_id}
                                    onChange={this.handleRouteChange}
                                    disabled={this.state.loadingLookups}
                                >
                                    <option value={""}>Seleziona percorso</option>
                                    {this.renderRouteOptions()}
                                </select>
                            </div>

                            {
                                this.state.vehicles.length > 0 &&
                                <div className={"form-group"}>
                                    <label>Veicolo</label>
                                    <select
                                        className={"form-control"}
                                        value={this.state.vehicle_id}
                                        onChange={this.handleVehicleChange}
                                        disabled={this.state.loadingLookups}
                                    >
                                        <option value={""}>Nessuno</option>
                                        {this.renderVehicleOptions()}
                                    </select>
                                </div>
                            }

                            <div className={"text-right"}>
                                <button
                                    type={"button"}
                                    className={"btn btn-primary"}
                                    onClick={this.handleSubmit}
                                >
                                    Salva richiesta
                                </button>
                            </div>
                        </div>
                    }
                />
            </Fragment>
        );
    }
}

NewAwayTripPage.propTypes = {
    active: PropTypes.bool,
    onDismiss: PropTypes.func,
    onTripCreated: PropTypes.func,
    staffList: PropTypes.array,
    selectedStaffId: PropTypes.number
};
